export default __webpack_public_path__ + "static/image_1-4ed3580d62a6f419a76247295c552839.png";